<template>
  <div>
    <h4>我的优惠卷</h4>
    <el-card class="box-card">
      
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  created() {

  },
  onload() {

  },
  methods: {

  },
}
</script>

<style scoped lang='scss'>

</style>